<template>
  <div class="profile-picture-wrapper" :class="`profile-picture-${variant}`">
    <img 
      :key="`profile-picture-${props.user?.id || 'default'}-${profilePictureUrl || 'empty'}`"
      :src="displayImage(profilePictureUrl)" 
      alt="Profile" 
      @error="handleImageError" 
      loading="lazy"
      class="profile-picture-image"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { displayImage, renderBannerDeco } from '@/shared/utils/generalUtils';

const props = defineProps({
  user: {
    type: Object,
    required: true
  },
  width: {
    type: [Number, String],
    default: 100
  },
  height: {
    type: [Number, String],
    default: 100
  },
  variant: {
    type: String,
    default: 'default'
  }
})

const sizeWidth = computed(() => Number(props.width) || 100);
const sizeHeight = computed(() => Number(props.height) || 100);

// Handle both direct user object and search result structure (user.raw)
const profilePictureUrl = computed(() => {
  return props.user?.profilePictureUrl || props.user?.raw?.profilePictureUrl;
});

const bannerDeco = computed(() => {
  return props.user?.banierDeco || props.user?.raw?.banierDeco;
});

function handleImageError(event) {
  const img = event.target;
  const defaultImg = displayImage(null);
  if (img.src !== defaultImg) {
    img.src = defaultImg;
  }
}
</script>

<style scoped>
.profile-picture-wrapper {
  border-radius: 50%;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  display: inline-block;
  flex-shrink: 0;
  box-sizing: border-box;
}

.profile-picture-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 50%;
}

/* Variante par défaut - utilise les props width/height */
.profile-picture-wrapper:not(.profile-picture-header):not(.profile-picture-mobile) {
  width: v-bind('sizeWidth + "px"');
  height: v-bind('sizeHeight + "px"');
  min-width: v-bind('sizeWidth + "px"');
  min-height: v-bind('sizeHeight + "px"');
  max-width: v-bind('sizeWidth + "px"');
  max-height: v-bind('sizeHeight + "px"');
}

/* Variante header - tailles responsives */
.profile-picture-header {
  width: 40px;
  height: 40px;
}

@media (max-width: 991.98px) {
  .profile-picture-header {
    width: 44px;
    height: 44px;
  }
}

@media (max-width: 575.98px) {
  .profile-picture-header {
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 375px) {
  .profile-picture-header {
    width: 38px;
    height: 38px;
  }
}
</style>